







import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import cola from "cytoscape-cola";

const generateSvg = (item: any) => {
  const { score, text } = item;

  const svg = `<svg width="285" height="285" viewBox="0 0 285 285" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="142.5" cy="142.5" r="142.132" fill="url(#paint0_radial)" stroke="#D7E8C7" stroke-width="0.736024"/>
  <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(142.5 142.5) rotate(90) scale(142.5)">
  <stop offset="0.411458" stop-color="#D7E8C7"/>
  <stop offset="0.807292" stop-color="#D7E8C7" stop-opacity="0.48"/>
  </radialGradient>
    <foreignObject x="15" y="10" width="100%" height="100%">
      <div xmlns="http://www.w3.org/1999/xhtml"
        style="width: 100%;
        height: 100%;
        position: relative;
        font-family: 'Arial';
      ">
        <div
          style="text-align: center;
          position: absolute;
          top: 50%;
          left: 45%;
          transform: translate(-50%, -50%);
          width: 100%;
          color: #647272;
        "
        >
          <span style="font-weight: 700; font-size: 42px;">${score}</span>
          <div
            style="font-weight: 200;
            font-size: 24px;
            width: 80%;
            margin: 4px auto 0;
          ">
            ${text}
          </div>
        </div>
      </div>
    </foreignObject>
  </svg>`;
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
};

@Component({
  name: "BubbleChart"
})
export default class Funnel extends Vue {
  @Prop({ type: Array, required: true }) readonly items!: [];

  @Watch('items')
  onUpdate(prev: any, next: any) {
    const cy = (this.$options as any).cy;
    if(!cy) {
      return;
    }

    cy.remove(cy.elements());

    this.assignItems(cy, next);
    cy.add(this.elements);
      cy.makeLayout({
      name: "cola",
      nodeSpacing: 500,
      padding: 0,
      flow: { axis: "x", minSeparation: 800 }
    }).run();
  }
  
  elements: Array<Object> = [];
  config = {
    userPanningEnabled: false,
    boxSelectionEnabled: false,
    autoungrabify: true,

    layout: {
      name: "cola"
    }
  };

  preConfig(cytoscape: any) {
    cytoscape.use(cola);
  }

  get maxValue() {
    return Math.max(...this.items.map((item: any) => item.score).filter(item => item));
  }

  assignItems(cy: any, items = this.items) {
    this.elements = [];
    this.items.forEach((item: any) => {
      const { score, text, id, target, source, type } = item;
      let nodeSize = Math.round((score * 200) / this.maxValue);

      if (type === "nodes") {
        this.elements.push({
          data: { id, score }
        });
      } else {
        this.elements.push({
          data: { source, target }
        });
      }

      if (!nodeSize) return;

      let size = Math.sqrt(nodeSize) * 250;

      cy.style()
        .selector(`#${id}`)
        .css({
          "background-image": generateSvg({ score, text }),
          width: `${size}%`,
          height: `${size}%`
        })
        .update();
    });

     cy.style()
      .selector("node")
      .css({
        "font-size": "50px",
        "text-valign": "center",
        "text-halign": "center",
        color: "#000",
        "overlay-padding": "6px",
        "z-index": "10",
        "background-fit": "cover",
        "background-color": "white"
      })
      .selector("edge")
      .css({
        width: 5,
        "line-color": "#DDDEDF"
      })
      .update();
  }

  cyReady(el: any) {
    const cy = el.cy;
    (this.$options as any).cy = el.cy;
    this.assignItems(cy);

    cy.add(this.elements);

    cy.makeLayout({
      name: "cola",
      nodeSpacing: 500,
      padding: 0,
      flow: { axis: "x", minSeparation: 800 }
    }).run();
  }

  beforeDestroy() {
      (this.$options as any).cy.height(0);
    (this.$options as any).cy.width(0);
    (this.$options as any).cy.destroyRenderer();
    (this.$options as any).cy.destroy();
    (this.$options as any).cy.unmount();
  }
  //   if(!this.element) {
  //     return;
  //   }

  //   this.element.destroyRenderer();
  //   this.element.destroy();
  //   console.log(this.element);
  // }
}
